export default function Skeleton({ className = "" }: { className?: string }) {
  return <div className={`dh-skeleton rounded-lg ${className}`} />;
}